import { useState, useEffect, useRef } from 'react';

const rollStart = (value: number) =>
    value >= 10 ? Math.pow(10, Math.floor(Math.log10(value))) : 0;

export function useAnimatedValue(value: number) {
    const [displayValue, setDisplayValue] = useState(() => rollStart(value));
    const [animated, setAnimated] = useState(false);
    const started = useRef(false);

    useEffect(() => {
        if (started.current) {
            setDisplayValue(value);
            return;
        }
        if (value <= 0) return;
        started.current = true;
        setDisplayValue(rollStart(value));
        requestAnimationFrame(() => {
            setAnimated(true);
            setDisplayValue(value);
        });
    }, [value]);

    return { displayValue, animated };
}
